import "../components/Button.css";

export function Button({ children, variant = "default", className = "", ...props }) {
  const variantClass = `btn--${variant}`
  
  return (
    <button className={`btn ${variantClass} ${className}`} {...props}>
      {children}
    </button>
  )
}

